export default class ContractWithdrawalIdentifyRequest {
    constructor(public name: string, public lastName: string, public contractNumber: string) {
    }
}
